export default __webpack_public_path__ + "static/media/fast4ward.d4fd2392.png";